"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationBellIcon = void 0;
var ToggleMenuFlyoutEvent = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const NotificationBellIcon = () => {
  const [ref, Icon] = (0, _hooks.useHover)(_icons.NotificationFilled, _icons.Notification);
  const [isClicked, setIsClicked] = (0, _react.useState)(false);
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    data
  } = (0, _globalApiClientReact.useGetCustomerUnseenNotificationsCount)(customerId, {
    [_fetching.CLIENT_APPLICATION]: 'Web' /* notifications API requires value `Web` */
  }, {
    swr: (0, _presentationUtils.getRetryErrorSwrOptions)()
  });
  const {
    count
  } = data ?? {
    count: 0
  };
  const handleClick = (0, _react.useCallback)(() => {
    UserAction.dispatch(_constants.CLICK_NOTIFICATION_ICON);
    setIsClicked(true);
    (0, _utils.dispatchToggleMenu)(ToggleMenuFlyoutEvent.MenuTypes.Notifications);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NotificationBellIconButton, {
    ref: ref,
    variant: "text",
    "aria-label": translations.notifications,
    "data-testid": getTestId(_constants2.NOTIFICATION_BELL_ICON_BUTTON),
    onClick: handleClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Badge, {
      color: "error",
      badgeContent: count,
      max: 99,
      "data-testid": getTestId(_constants2.NOTIFICATION_BELL_ICON_BELL),
      invisible: isClicked || count === 0,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        fontSize: "inherit"
      })
    })
  });
};
exports.NotificationBellIcon = NotificationBellIcon;